import React from 'react';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';

const ScheduleBasicInfo = ({ formData, fieldPrefix, scheduleType }) => {
  return (
    <div className={newLeaseModalStyles.newLeaseModalSection}>
      <div className={newLeaseModalStyles.sectionHeader}>
        <h3 className={newLeaseModalStyles.sectionTitle}>
          Schedule Information
        </h3>
      </div>
      <div className={newLeaseModalStyles.sectionContent}>
        <div
          className={
            scheduleType !== 'once' ? 'pm-flex pm-flex-4' : 'pm-flex pm-flex-2'
          }
        >
          <div className="pm-flex pm-flex-col">
            <div className="mdc-form-field mdc-form-field--align-end">
              <div
                className="mdc-text-field pm-margin-none"
                data-mdc-auto-init="MDCTextField"
              >
                <input
                  type="text"
                  className="mdc-text-field__input"
                  id="schedule-name"
                  name={`${fieldPrefix}[name]`}
                  defaultValue={formData.name}
                />
                <label htmlFor="schedule-name" className="mdc-floating-label">
                  Schedule Name
                </label>
              </div>
            </div>
          </div>
          <div className="pm-flex pm-flex-col">
            <div className="mdc-form-field mdc-form-field--align-end">
              <div
                className="mdc-text-field pm-margin-none"
                data-mdc-auto-init="MDCTextField"
              >
                <input
                  type="text"
                  className="mdc-text-field__input pm-datepicker-field"
                  id="schedule-start-date"
                  name={`${fieldPrefix}[start_date]`}
                  defaultValue={formData.startDate}
                />
                <label
                  htmlFor="schedule-start-date"
                  className="mdc-floating-label"
                >
                  Start Date
                </label>
              </div>
            </div>
          </div>
          {scheduleType !== 'once' && (
            <div className="pm-flex pm-flex-col">
              <div className="mdc-form-field mdc-form-field--align-end">
                <div
                  className="mdc-text-field pm-margin-none once-inapplicable-fields"
                  data-mdc-auto-init="MDCTextField"
                >
                  <input
                    type="text"
                    className="mdc-text-field__input pm-datepicker-field"
                    id="schedule-end-date"
                    name={`${fieldPrefix}[end_date]`}
                    defaultValue={formData.endDate}
                    disabled={scheduleType === 'once'}
                  />
                  <label
                    htmlFor="schedule-end-date"
                    className="mdc-floating-label"
                  >
                    End Date
                  </label>
                </div>
              </div>
            </div>
          )}
          {scheduleType !== 'once' && (
            <div className="pm-flex pm-flex-col">
              <div className="mdc-form-field once-inapplicable-fields">
                <div id="mdc-js-checkbox" className="mdc-checkbox">
                  <input
                    type="hidden"
                    name={`${fieldPrefix}[month_to_month]`}
                    value="0"
                  />
                  <input
                    type="checkbox"
                    className="mdc-checkbox__native-control"
                    id="schedule-month-to-month"
                    name={`${fieldPrefix}[month_to_month]`}
                    defaultChecked={formData.monthToMonth}
                    value="1"
                  />
                  <div className="mdc-checkbox__background">
                    <svg
                      className="mdc-checkbox__checkmark"
                      viewBox="0 0 24 24"
                    >
                      <path
                        className="mdc-checkbox__checkmark-path"
                        fill="none"
                        stroke="white"
                        d="M1.73,12.91 8.1,19.28 22.79,4.59"
                      />
                    </svg>
                    <div className="mdc-checkbox__mixedmark"></div>
                  </div>
                </div>
                <label htmlFor="schedule-month-to-month">Month to month</label>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScheduleBasicInfo;
